var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('v-btn',{attrs:{"small":"","icon":""},on:{"click":function($event){return _vm.$emit('remove', _vm.dataRow.id)}}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("delete_outline")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }